import { Attribute } from 'services/generated/commerce-service/models/Attribute';
import { VARIANT_ATTRIBUTE_NAMES } from '../constants/maverick';
import { PlanTypes } from 'ui/utils/constants/maverick';

export const getIsTypeFromAttributes = (
  attributes: Attribute[] | undefined,
  type: PlanTypes,
): boolean => {
  if (!attributes) {
    return false;
  }
  return attributes.some(
    (attr) =>
      attr.name === VARIANT_ATTRIBUTE_NAMES.SUBSCRIPTION_TYPE &&
      attr.value.key === type,
  );
};

export const getIsFamilyFromAttributes = (
  attributes: Attribute[] | undefined,
): boolean => {
  if (!attributes) {
    return false;
  }
  return attributes.some(
    (attr) =>
      attr.name === VARIANT_ATTRIBUTE_NAMES.FAMILY_SIZE && Boolean(attr.value),
  );
};

export const getIsTwoYearFromAttributes = (
  attributes: Attribute[] | undefined,
): boolean => {
  if (!attributes) {
    return false;
  }
  return attributes.some(
    (attr) =>
      attr.name === VARIANT_ATTRIBUTE_NAMES.TRIAL_DAYS && attr.value === 730,
  );
};
